// extracted by mini-css-extract-plugin
export default {"wrapper":"SupportsHeader_wrapper__Os6oi"};